import { createAction, props } from '@ngrx/store';
import { PmsProduct } from '../../interfaces/pms-product.interface';

export const GetProducts = createAction(
  '[Products] Get Products'
);

export const GetProductsSuccess = createAction(
  '[Products] Get Products Success',
  props<{products: PmsProduct[]}>()
);

export const GetProductsFail = createAction(
  '[Products] Get Products Fail'
);